/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AccountGroup} from '../models/AccountGroup';
import type {Error} from '../models/Error';

export interface GetAccountGroups$Request {
    accountId: number;
}

export interface GetAccountGroups$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAccountGroupsRequest = createAction<PayloadData<void, GetAccountGroups$Request>>('GET_ACCOUNT_GROUPS__GET_ACCOUNT_GROUPS__REQUEST');
export const getAccountGroupsSuccess = createAction<PayloadData<Array<AccountGroup>, GetAccountGroups$Request>>('GET_ACCOUNT_GROUPS__GET_ACCOUNT_GROUPS__SUCCESS');
export const getAccountGroupsFailure = createAction<PayloadData<Error, GetAccountGroups$Request, true>>('GET_ACCOUNT_GROUPS__GET_ACCOUNT_GROUPS__FAILURE');

export const getAccountGroupsActions = [
    getAccountGroupsRequest,
    getAccountGroupsSuccess,
    getAccountGroupsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAccountGroups = (meta: GetAccountGroups$Request, config?: GetAccountGroups$Config) => {
    return {
        CALL_API: {
            types: getAccountGroupsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/accounts/${meta.accountId}/groups/names`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

